<template>
  <ValidationProvider
    v-slot="{ errors }"
    :rules="rules"
    :custom-messages="_customMessages"
  >
    <input
      type="hidden"
      :value="value"
    >
    <div
      v-if="errors.length > 0"
      class="invalid-text"
    >
      <div
        v-for="(text_e,text_k) in errors"
        :key="text_k"
      >
        <WsTextChip001
          class="mt-20"
          red
          icon-lg
          :text-label="text_e"
          leading-icon="icon-info"
        />
      </div>
    </div>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
extend("quizAnswerRequired", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "WsStateHideInputError",
  components: {
    ValidationProvider,
  },
  props: {
    errorMessages: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
    value: {
      type: [Number, String, Object, Array],
      default: null,
    },
  },
  computed: {
    _customMessages() {
      return {
        quizAnswerRequired: this.errorMessages,
      };
    },
  },
};
</script>